import React, { Component } from 'react';
import PubSub from 'pubsub-js'
import {  ScheduleOutlined ,PlusOutlined} from '@ant-design/icons';
import { meshLog } from "../../../utils/spUtils";
import {SET_ASSOCIATE_DIALOG_HIDE} from "../../../const/infoConst"
import { Form, Input, Button, Checkbox, message } from "antd";
import './setAssociateDialog.less';
import close_btn from '../../../imgs/btn/close_btn.png';
import sensor from "../../../imgs/item/sensor.png";

//设备设置界面
export default class SetAssociateDialog extends Component {
    constructor(a) {
        super(a);
        this.state = {
            selectedValue:"getway", //getway local
        }
    }


    closeBtnClick = async () => {
        meshLog("closeBtnClick");
        PubSub.publish(SET_ASSOCIATE_DIALOG_HIDE,'')
    }

    handleRadioChangeGetway = (e) => {
        this.setState({
            selectedValue:"getway", 
        })
    };
    handleRadioChangeLocal = (e) => {
        this.setState({
            selectedValue:"local", 
        })
    };


    render() {
        const { selectedValue } = this.state;
        return (
            <div className="asso_container">
                <div className="ui_grey_bg" />
                <div className="asso_dialog" style={{left:(document.body.clientWidth-600)/2}}>
                     {/* 关闭按钮 */}
                    <img className='closeBtn' src={close_btn} onClick={() => { this.closeBtnClick() }}/>
                    {/* 标题 */}
                    <div className="asso_title">
                        <img className='icon' src={sensor}/>
                        <span>Select Associated Device Type</span>
                    </div>
                    {/* 单选框 */}
                    <div className='getwayBg'>
                        <div className="user-title">
                            <span>Gateway Settings</span>
                            <input className="radioSet" type='radio' name='select' value='' style={{accentColor:'#FFBD27'}} checked={selectedValue=="getway"} onChange={this.handleRadioChangeGetway}/>
                        </div>
                        <span>The schedule management gateway deployed in the project will automatically record various schedule events. These events support remote creation and modification operations, with no on-site configuration required.</span>
                    </div>
                    <div className='localBg'>
                        <div className="user-title">
                            <span>Local Settings</span>
                            <input className="radioSet" type='radio' name='select' value='' style={{accentColor:'#FFBD27'}} checked={selectedValue=="local"} onChange={this.handleRadioChangeLocal}/>
                        </div>
                        <span>Devices involved in the project will directly call schedule events. If changes to the events are needed, the relevant configuration operations must be completed on-site.</span>
                    </div>

                    {/* 底部按钮 */}
                    <div className="asso-footer">
                        <button className='cancelBtn' onClick={() => { this.closeBtnClick() }}>Cancel</button>
                        <button className='okBtn' onClick={() => { this.closeBtnClick() }}>Confirm</button>
                    </div>
           
               
                </div>
            </div>
        );

    }
};